import { render } from "./App.vue?vue&type=template&id=3aea4ab0"
const script = {}

import "@/css/fonts.css?vue&type=style&index=0&lang=css&external"
import "@/css/global.css?vue&type=style&index=1&lang=css&external"
import "@/css/animations.css?vue&type=style&index=2&lang=css&external"
import "@/css/foneturk-alert.css?vue&type=style&index=3&lang=css&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__